import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { IIrowPlans } from '../components/toolComponents/irow/irow.model';

@Injectable({
    providedIn: 'root'
})
export class IrowService {
    constructor(private readonly api: Api) { }

    public async getPlans(county: string, route: string, segment: string): Promise<IIrowPlans> {
        return this.api.http2.get(`irow/plans/${county}/${route}/${segment}`);
    }
}
